"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "The AI Assessment was a wake-up call. Olivia identified 12 hours of manual data entry we could automate instantly. Truly a premium service.",
  firstName: "Jonathan",
  lastName: "Vance",
  industry: "Logistics"
}, {
  quote: "RecoupTime doesn't just suggest tools; they provide a roadmap for efficiency. The assessment paid for itself in the first week.",
  firstName: "Sarah",
  lastName: "Miller",
  industry: "Consulting"
}, {
  quote: "I was skeptical about a 20-minute call, but the report I received 48 hours later was the most detailed operational audit I've ever seen.",
  firstName: "Robert",
  lastName: "Chen",
  industry: "Manufacturing"
}, {
  quote: "Finding 'hidden hours' seemed like a marketing gimmick until we saw the data. We've reclaimed nearly 15% of our work week.",
  firstName: "Elena",
  lastName: "Rossi",
  industry: "Design"
}, {
  quote: "The precision of the AI Assessment is unmatched. It's the high-end consulting experience small businesses have been missing.",
  firstName: "Marcus",
  lastName: "Thorne",
  industry: "Finance"
}];
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="238133" id="testimonials" className="bg-background text-foreground">
      <div className="w-full bg-background py-24 lg:py-32 overflow-hidden">
        <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="max-w-[90rem] mx-auto">
            <Carousel opts={{
            align: "start",
            loop: true
          }} className="w-full">
              <CarouselContent className="-ml-4 md:-ml-6">
                {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                    <div className="h-full py-2">
                      <Card className="h-full border border-border rounded-lg shadow-md bg-card transition-colors duration-300 hover:border-primary/50 group">
                        <CardContent className="p-8 md:p-10 flex flex-col justify-between h-full gap-10">
                          <div className="flex flex-col gap-6">
                            <div className="size-16 rounded-lg border border-border bg-muted flex items-center justify-center grayscale group-hover:grayscale-0 transition-colors duration-500">
                              <span className="font-mono font-bold text-primary text-lg">
                                {testimonial.firstName.charAt(0).toUpperCase()}{testimonial.lastName.charAt(0).toUpperCase()}
                              </span>
                            </div>
                            <p className="font-default font-medium italic text-foreground text-lg md:text-xl leading-relaxed">
                              "{testimonial.quote}"
                            </p>
                          </div>
                          <div className="font-mono text-xs md:text-sm uppercase tracking-widest text-primary">
                            <span className="font-default font-bold text-primary">
                              {testimonial.firstName} {testimonial.lastName.charAt(0)}.
                            </span>
                            <span className="text-muted-foreground/20 mx-3 inline-block align-middle">•</span> 
                            <span className="text-muted-foreground/70">{testimonial.industry}</span>
                          </div>
                        </CardContent>
                      </Card>
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
              
              <div className="flex items-center justify-end gap-4 mt-12 pr-2">
                <CarouselPrevious variant="outline" className="relative inset-auto translate-y-0 translate-x-0 size-12 rounded-lg border-border text-foreground hover:bg-primary hover:text-primary-foreground bg-secondary transition-colors duration-300" />
                <CarouselNext variant="outline" className="relative inset-auto translate-y-0 translate-x-0 size-12 rounded-lg border-border text-foreground hover:bg-primary hover:text-primary-foreground bg-secondary transition-colors duration-300" />
              </div>
            </Carousel>
          </div>
        </div>
      </div>
    </section>;
}